/** Cycle each headline every ~2.3s on the countdown stage. */
export const WELCOME_TRANSLATIONS = [
  { lang: 'es', text: 'Bienvenido' },
  { lang: 'en', text: 'Welcome' },
  { lang: 'pt', text: 'Bem-vindo' },
  { lang: 'fr', text: 'Bienvenue' },
  { lang: 'gn', text: 'Eguahẽ porã' },
  { lang: 'qu', text: 'Napaykullayki' },
  { lang: 'zh', text: '欢迎' },
  { lang: 'ja', text: 'ようこそ' },
  { lang: 'sw', text: 'Karibu' },
  { lang: 'gd', text: 'Fàilte' },
  { lang: 'nl', text: 'Welkom' },
];
